/**
 * Badge classes for a cookie's status. Shared by the cookie list and the cookie
 * form so a status reads identically wherever it appears — green/red are kept as
 * semantic state colours rather than the ink/arwen chrome scales.
 */
export const cookieStatusBadge = (status: string) =>
    status === 'ACTIVE'
        ? 'text-green-700 bg-green-50 ring-1 ring-inset ring-green-600/20'
        : 'text-red-700 bg-red-50 ring-1 ring-inset ring-red-600/20'
